import { useDispatch, useSelector } from "react-redux";
import FilterPagesGeneral from "../../components/FilterPagesGeneral";
import { fetchListItems, setPageType } from "../../redux/actions/actions";
import { useEffect } from "react";

export default function MyCommissions() {
  const filterMethods = ["status", "issue_date"];
  const buttons = ["export_report"];

  return (
    <FilterPagesGeneral
      pageName={"commissions"}
      filterMethods={filterMethods}
      buttonTypes={buttons}
    />
  );
}
